import { render, staticRenderFns } from "./LeadNewLeadCard.vue?vue&type=template&id=58b12b4b&scoped=true&"
import script from "./LeadNewLeadCard.vue?vue&type=script&lang=js&"
export * from "./LeadNewLeadCard.vue?vue&type=script&lang=js&"
import style0 from "./LeadNewLeadCard.vue?vue&type=style&index=0&id=58b12b4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b12b4b",
  null
  
)

export default component.exports